var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-pagination',{attrs:{"showTotal":total => `共 ${total} 条`,"showQuickJumper":"","showSizeChanger":"","total":_vm.total},on:{"change":_vm.change,"showSizeChange":_vm.showSizeChange},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})
}
var staticRenderFns = []

export { render, staticRenderFns }